export var top = 'nlQwP';
export var topReverse = 'F5J98';
export var middle = '_3aTb2';
export var bottom = '_2Kk61';
export var bottomReverse = '_2pDVe';
export var paused = '_9avsr';